module.exports = __webpack_public_path__ + "static/hanusova-75c6d279966188671e1cc0d166cab7ca.jpg";